export const handleStart = () => {
    const width = 1920;
    const height = 1080;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
 
    const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'resizable=no',
    'scrollbars=no',
    'toolbar=no',
    'menubar=no',
    'status=no'
    ].join(',');
 
    window.open('/play', '_blank', features);
 };